import { render, staticRenderFns } from "./unavailability-tab.vue?vue&type=template&id=20bf2672"
import script from "./unavailability-tab.ts?vue&type=script&lang=js&external"
export * from "./unavailability-tab.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bf2672')) {
      api.createRecord('20bf2672', component.options)
    } else {
      api.reload('20bf2672', component.options)
    }
    module.hot.accept("./unavailability-tab.vue?vue&type=template&id=20bf2672", function () {
      api.rerender('20bf2672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/tabs/unavailability-tab/unavailability-tab.vue"
export default component.exports